module.exports = __webpack_public_path__ + "static/tampa-bay-plumbing-22eaaa5bd3827671c22b6f2d41109945.svg";